import React from "react";
import { NavLink } from "react-router-dom";

export default function DigitalMediaMarketing() {
  return (
    <section className="container page-top pt-10" style={{ paddingTop: "6rem" }}>
      <div className="container">
        {/* Title Section */}
        <div className="row mb-4">
          <div className="col-12 text-center">
            <h1 className="display-5 fw-bold text-primary">Digital Media Marketing</h1>
            <h5 className="text-muted">
              Strategic Campaigns to Amplify Your Brand in the Digital Space
            </h5>
            <hr className="w-25 mx-auto" />
          </div>
        </div>

        {/* Image and Introduction */}
        <div className="row align-items-center mb-5">
          <div className="col-md-6">
            <img
              src="https://img.freepik.com/free-vector/marketing-strategy-concept_23-2148575084.jpg"
              alt="Digital Marketing Strategy"
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6">
            <h2 className="fw-semibold">Results-Driven Digital Marketing</h2>
            <p>
              At <strong>Bytlas Intelligence</strong>, we go beyond just posting content — we craft
              complete digital marketing strategies that drive engagement, leads, and conversions.
              From SEO and PPC to email and influencer campaigns, we align your brand with success.
            </p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ Google Ads & Search Engine Marketing (SEM)</li>
              <li className="list-group-item">✅ Social Media Ad Campaigns (Meta, LinkedIn, Insta)</li>
              <li className="list-group-item">✅ Email Marketing & Automation</li>
              <li className="list-group-item">✅ Campaign Analytics & Performance Reports</li>
            </ul>
          </div>
        </div>

        {/* Features Section */}
        <div className="row my-5">
          <div className="col-md-6">
            <h3 className="text-secondary">Multi-Channel Marketing Strategy</h3>
            <p>
              We design a cohesive digital presence across platforms like Google, Facebook, LinkedIn,
              Instagram, and YouTube. Every ad, post, and campaign is built with ROI in mind.
            </p>
            <ul>
              <li>📊 Campaign Strategy & Market Research</li>
              <li>🎯 Targeted Audience Segmentation</li>
              <li>📈 Performance Tracking with UTM Tags</li>
              <li>💬 A/B Testing & Optimization</li>
            </ul>
          </div>

          <div className="col-md-6">
            <h3 className="text-secondary">Brand Visibility & Engagement</h3>
            <p>
              Engage audiences through well-crafted campaigns that build brand recall and 
              generate quality leads. From story ads to search campaigns, our creative media 
              strategies ensure visibility where it matters most.
            </p>
            <ul>
              <li>📢 Awareness & Lead Generation Campaigns</li>
              <li>📍 Location-Based & Interest-Based Targeting</li>
              <li>🛒 Conversion Tracking & Funnel Setup</li>
              <li>🧠 AI Tools for Keyword & Content Insights</li>
            </ul>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-4">
          <NavLink to="/contact" className="btn btn-danger px-4 py-2 rounded-pill fw-bold">
            Launch Your Campaign Today
          </NavLink>
        </div>
      </div>
    </section>
  );
}
